"use client";

import { Spinner, cn } from "@jace/ui";
import { motion } from "framer-motion";
import {
	PropsWithChildren,
	ReactElement,
	useEffect,
	useRef,
	useState,
} from "react";
import { RendererProps } from "./types";

export function ImageRenderer({
	url,
	zoom,
	children,
}: PropsWithChildren<RendererProps>): ReactElement {
	const imgRef = useRef<HTMLImageElement>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);

		if (imgRef.current?.complete) {
			setIsLoading(false);
		}
	}, [url]);

	return (
		<div className="flex h-[calc(90vh-100px)] items-center justify-center overflow-auto p-4 relative">
			{isLoading ? (
				<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
					<Spinner color="#FFFFFF" />
				</div>
			) : null}
			<motion.img
				ref={imgRef}
				alt="File preview"
				className={cn(
					"object-contain h-full",
					isLoading ? "opacity-0" : "opacity-100",
				)}
				initial={{ opacity: 0 }}
				animate={{ opacity: isLoading ? 0 : 1 }}
				height={1000}
				onLoad={() => {
					console.log("ImageRenderer:onLoad");
					setIsLoading(false);
				}}
				src={url}
				style={{
					transform: `scale(${zoom})`,
				}}
				width={1000}
			/>
			{children}
		</div>
	);
}
